import axios from "axios";

// ✅ create axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
  withCredentials: true, // cookies allow
});

// ✅ request interceptor (add token to headers)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ response interceptor (handle 401)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // remove token if invalid
      localStorage.removeItem("token");
      window.location.href = "/login"; // redirect
    }
    return Promise.reject(error);
  }
);

export default api;
